<template >
  <div name="dynamicfile">
    <div
      style="width: 100%; text-align: center"
      class="spin-holder"
      v-if="loading"
    >
      <i class="spinner fa fa-atom fa-spin"></i>
      <p>Loading File</p>
    </div>

    <div v-else>
      <div v-if="fileAllowed">
        <template v-if="isPDF && isImage == false">
          <pdf ref="myPdfComponent" v-for="i in numPages" :key="i" :page="i" :src="pdfsrc" >
            <template slot="loading">
        loading content here...
      </template>
    </pdf>
        </template>
       
        <iframe
          :src="pathUrl"
          width="100%"
          height="1200px"
          v-else-if="isImage == false"
        />
        <img
          :src="pathUrl"
          :alt="name"
          class="gallery-image"
          ref="reference"
          :title="name"
          @contextmenu.prevent="handler"
          v-else
        />
      </div>
      <p v-else>File not permitted on this platform</p>
    </div>
    <div class="hidebtn">&nbsp;</div>
  </div>
</template>

  <script>
import { mapGetters } from "vuex";

import pdfvuer from 'pdfvuer'

import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";

export default {
  name: "dynamicfile",
  mixins: [fileResourceMixin],
  props: {
    url: { type: String, required: true },
    name: { type: String, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    extension() {
      return this.url.split(".").pop();
    },
    isImage() {
      let imageExtensions = ["jpg", "png"];
      return imageExtensions.includes(this.extension);
    },
    isPDF() {
      return this.extension === "pdf";
    },
    fileAllowed() {
      return true; //this.currentUser.schoolStyle != 'lancashire'
    },
  },
  data: function () {
    return {
      pathUrl: "",
      numPages: null,
      loading: true,
      pdfsrc: null,
    };
  },
  created() {
    if (this.isPDF) {
      this.loadData();
    } else {
      this.loadMedia()
    }
   
  },
  mounted() {},
  methods: {
    errorCaptured() {
    return false
  },
    loadData() {
      setTimeout(() => {
        this.getLessonDocumentData(this.url).then((result) => {
          const url = URL.createObjectURL(result.Body);
          this.pdfsrc = pdfvuer.createLoadingTask(url);
          this.pdfsrc.then((pdf) => {
            this.numPages = pdf.numPages;
          });
          this.loading = false;
        });
      }, 1000);
    },
    loadMedia() {
      setTimeout(() => {
        this.getLessonDocument(this.url)
          .then((f) => {
            var encodedUrl = encodeURIComponent(f);
            let file = (this.pathUrl =
              this.isImage == true || this.extension == "pdf"
                ? f
                : "https://docs.google.com/viewer?url=" +
                  encodedUrl +
                  "&embedded=true");
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      }, 1000);
    },
    checkImage(ref) {
      // console.log(this.$refs.reference.$el)
      // EXIF.getData(this.$refs.reference.$el, function () {
      //     alert(this.exifdata.Orientation);
      // });
    },
  },
  components: {
    pdf: pdfvuer
  },
};
</script>


<style scoped>
.document {
  padding-top: -50px;
}

.modal-container {
  width: 90%;
}

.toolbarButton {
  display: none;
}

.hidebtn {
  width: 100px;
  height: 30px;
  background: #ff0000;
  position: absolute;
  left: 0px;
  top: -900px;
  display: none;
}
</style>

